import React, { useState, useMemo } from "react";
import ReactSelect from "react-select";
import { useStyles } from "./useStyles";

export const ProductsSelect = ({
  value,
  options = [],
  onChange,
  isClearable,
  customStyles,
  isMulti,
  index,
  selectedSkus = [], // Default to empty array
  selectedProducts = [], // Default to empty array
  key,
}) => {
  const [isSearchable] = useState(true);

  // Function to sort options with the selected value for this specific dropdown on top
  const sortOptions = (options, selectedValue) => {
    if (!Array.isArray(options)) {
      return [];
    }

    // Place the selected value first if it exists
    const selectedOption = options.find(
      (option) => option.value === selectedValue
    );
    const otherOptions = options.filter(
      (option) => option.value !== selectedValue
    );

    return selectedOption ? [selectedOption, ...otherOptions] : otherOptions;
  };

  // Get the selected value for this specific dropdown
  const selectedValue = selectedSkus[index]
    ? selectedSkus[index].value
    : selectedProducts[index]
    ? selectedProducts[index].value
    : null;

  // Memoize sorted options based on selectedValue and index
  const sortedOptions = useMemo(
    () => sortOptions(options, selectedValue),
    [options, selectedValue, index]
  );

  return (
    <ReactSelect
      key={key}
      value={value}
      isClearable={isClearable}
      isSearchable={isSearchable}
      options={sortedOptions}
      onChange={onChange}
      isMulti={isMulti}
      styles={customStyles || useStyles}
    />
  );
};
